<template>
    <div>
        <h6 style="font-weight: bold">{{ title }}</h6>
        <span>
            {{ $t('history.label.Created') }}: {{ shipmentInfo.createdAt.substring(0, 10) }}
            {{ shipmentInfo.createdAt.substring(11, 19) }}
            <br />
        </span>
        <span>
            {{ $t('history.label.CreatedBy') }}: {{ shipmentInfo.createdBy }}
            <br />
        </span>
        <span>
            {{ $t('history.label.ShipDate') }}: {{ shipment.shipDate.substring(0, 10) }}
            <br />
        </span>
        <span>
            {{ $t('history.label.ExpectedDeliveryDate') }}: {{ shipmentInfo.expectedDeliveryDate.substring(0, 10) }}
            <br />
        </span>
        <span>
            {{ $t('history.label.AWB') }}:
            <a v-if="shipment.bookingType !== BOOKING_TYPES.QUOTE_BOOKING.toString()"
                style="text-decoration: underline"
                :href="shipment.trackingLink"
                target="_blank"
            >
                {{ shipment.shipmentRef }}
                <br />
            </a>
        <a v-else
        >
                {{ shipment.shipmentRef }}
                <br />
            </a>
        </span>
        <span v-if="shipmentInfo.pickupRef">
            {{ $t('history.label.ExternalPickupReference') }}:
            <a
                v-bind:href="
                    `mailto:?subject=AWB ${shipment.shipmentRef} Pickup Reference: ${shipmentInfo.pickupRef}`
                "
            >{{ shipmentInfo.pickupRef }}</a>
            <br />
        </span>
        <span>
            {{ $t('history.label.Status') }}: {{ shipment.deliveryStatus }}
            <br />
        </span>
        <span>
            {{ $t('history.label.Company') }}: {{ shipmentInfo.company.name }}
            <br />
        </span>
        <span>
            {{ $t('history.label.Account') }}: {{ shipment.companyAccountName }}
            <br />
        </span>
        <span
            v-if="
                shipmentInfo.pickupReadyAt != '00:00:00' && shipmentInfo.pickupCloseAt != '00:00:00'
            "
        >
            {{ $t('history.label.PickupReady') }}: {{ shipmentInfo.pickupReadyAt }} -
            {{ $t('history.label.PickupClose') }}: {{ shipmentInfo.pickupCloseAt }}
            <br />
        </span>
        <span v-else>
            {{ $t('history.label.NoPickup') }}
            <br />
        </span>

        <span>
            {{ $t('history.label.TransportProduct') }}: {{ shipment.transportProductName }}
            <br />
        </span>
        <span v-if="shipmentInfo.alternativeTransportProductUsed">
            {{ $t('history.label.AlternativeTransportProduct') }}
            <br />
        </span>
        <span>
            {{ $t('history.label.SalesProduct') }}: {{ shipment.salesProduct }}
            <br />
        </span>
        <span>
            {{ $t('history.label.SendersReference') }}: {{ shipment.sendersReference }}
            <br />
        </span>
        <span>
            {{ $t('history.label.ReceiversReference') }}: {{ shipment.receiversReference }}
            <br />
        </span>
        <span v-if="hasShipFromBookingInitials">
        {{ $t('history.label.Initials') }}: {{ shipment.shipFromBookingInitials }}
        <br />
        </span>
        <span v-if="hasShipFromBookingDepartment">
        {{ $t('history.label.Department') }}: {{ shipment.shipFromBookingDepartment }}
        <br />
        </span>
        <span v-if="hasBehalfOfInitials">
        {{ $t('history.label.OnBehalfOfInitials') }}: {{ shipmentInfo.onBehalfOfInitials  }}
        <br />
        </span>
        <span v-if="hasBehalfOfDepartment">
        {{ $t('history.label.OnBehalfOfDepartment') }}: {{ shipmentInfo.onBehalfOfDepartment  }}
        <br />
        </span>

        <h6
            class="mt-2"
            style="font-weight: bold"
        >{{ $t('history.label.PackageDetails') }}</h6>
        <span v-if="shipmentInfo.billableSalesWeight != null">
            {{ $t('history.label.BillableWeight') }}:
            {{ localizedNumber(shipmentInfo.billableSalesWeight) }}
            <br />
        </span>
      <span v-if="shipmentInfo.billableSalesWeight == null">
            {{ $t('history.label.BillableWeight') }}:
            {{ $t('history.label.PrColli') }}
            <br />
        </span>
      <span v-if="shipmentInfo.billableCostWeight != null && isAdminOrSuperUser">
            {{ $t('history.label.BillableCostWeight') }}:
            {{ localizedNumber(shipmentInfo.billableCostWeight) }}
            <br />
        </span>
      <span v-if="shipmentInfo.billableCostWeight == null && isAdminOrSuperUser">
            {{ $t('history.label.BillableCostWeight') }}:
            {{ $t('history.label.PrColli') }}
            <br />
        </span>
        <span>
            {{ $t('history.label.NumberOfPackages') }}: {{ shipmentInfo.numberOfColli }}
            <br />
        </span>
        <span>
            {{ $t('history.label.GoodsDescription') }}: {{ shipmentInfo.goodsDescription }}
            <br />
        </span>

        <div v-if="shipment.services.length > 0">
            <h6
                class="mt-2"
                style="font-weight: bold"
            >{{ $t('history.label.Services') }}</h6>
            <div v-for="(item, index) in shipment.services" v-bind:key="index">
                <span>
                    {{ $t('history.label.Service') }}: {{ item }}
                    <br />
                </span>
            </div>
        </div>
      <div v-if="shipmentInfo.services != null && shipmentInfo.services.length > 0">
        <h6
            class="mt-2"
            style="font-weight: bold"
        >{{ $t('history.label.Services') }}</h6>
        <div v-for="(item, index) in shipmentInfo.services" v-bind:key="index">
                <span>
                    {{ $t('history.label.Service') }}: {{ item }}
                    <br />
                </span>
        </div>
      </div>
    </div>
</template>
<script>
  import localization from '@/mixins/localizationMixin';
  import {BOOKING_TYPES} from "@/store/nameConstants";
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters('core', ['isAdminOrSuperUser']),
      BOOKING_TYPES() {
        return BOOKING_TYPES
      },
      hasShipFromBookingInitials() {
        return this.shipment.shipFromBookingInitials  !== null && this.shipment.shipFromBookingInitials  !== '';
      },
      hasShipFromBookingDepartment() {
        return this.shipment.shipFromBookingDepartment   !== null && this.shipment.shipFromBookingDepartment   !== '';
      },
      hasBehalfOfInitials() {
        return this.shipmentInfo.onBehalfOfInitials !== null && this.shipmentInfo.onBehalfOfInitials !== '';
      },
      hasBehalfOfDepartment() {
        return this.shipmentInfo.onBehalfOfDepartment !== null && this.shipmentInfo.onBehalfOfDepartment !== '';
      }
    },
      components: {},

      mixins: [localization],

      props: {
          title: { type: String, required: true },
          shipment: { type: Object, required: true },
          shipmentInfo: { type: Object, required: true },
      },

      data() {
          return {};
      },

      methods: {},
  };
</script>

<style></style>
